var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtisteFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "artiste_fb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_794_1045",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H60V59.6367H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_794_1045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9996 30.0018C59.9996 13.4322 46.5674 0 29.9979 0C13.4283 0 -0.00390625 13.4322 -0.00390625 30.0018C-0.00390625 44.9765 10.9673 57.3883 25.3101 59.639V38.6741H17.6924V30.0018H25.3101V23.392C25.3101 15.8728 29.7891 11.7194 36.6422 11.7194C39.9246 11.7194 43.358 12.3054 43.358 12.3054V19.6887H39.5749C35.8479 19.6887 34.6856 22.0013 34.6856 24.3739V30.0018H43.0064L41.6763 38.6741H34.6856V59.639C49.0284 57.3883 59.9996 44.9765 59.9996 30.0018Z",
    fill: "#1877F2"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6762 38.6735L43.0064 30.0011H34.6856V24.3732C34.6856 22.0006 35.8478 19.688 39.5748 19.688H43.3579V12.3047C43.3579 12.3047 39.9246 11.7188 36.6421 11.7188C29.7891 11.7188 25.31 15.8721 25.31 23.3913V30.0011H17.6924V38.6735H25.31V59.6384C26.8375 59.878 28.403 60.0028 29.9978 60.0028C31.5926 60.0028 33.1581 59.878 34.6856 59.6384V38.6735H41.6762Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtisteFb);
export default __webpack_public_path__ + "static/media/artiste_fb.d914d5bea02a49408c03de10d6562078.svg";
export { ForwardRef as ReactComponent };